// extracted by mini-css-extract-plugin
module.exports = {"Content":"Explanation_Content__XJaAg","Header":"Explanation_Header__3eaWo"};